import { inject, Injectable } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import { getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { Y42RouterService, Y42Routes } from '@y42/feature/routing';
import { GitQuery } from '@y42/git';
import { AbstractJobService, JobContextService, JobHttpService, JobTriggerService } from '@y42/job';
import { Y42FeatureType } from '@y42/json-schema';
import {
  ExportStoreQuery,
  ExportTriggerJobHttpModel,
  ExportTriggerJobQuery,
  ExportTriggerJobStore,
  ExportTriggerStore,
} from '../../state';

@Injectable({ providedIn: 'root' })
export class ExportTriggerJobService extends AbstractJobService {
  constructor(
    triggerStore: ExportTriggerStore,
    jobStore: ExportTriggerJobStore,
    triggerService: JobTriggerService,
    jobQuery: ExportTriggerJobQuery,
    jobContext: JobContextService,
    gitQuery: GitQuery,
    errorHandlerService: ErrorHandlerService,
    jobHttpService: JobHttpService<ExportTriggerJobHttpModel>,
  ) {
    super(
      triggerService,
      triggerStore,
      jobStore,
      jobQuery,
      jobContext,
      gitQuery,
      errorHandlerService,
      jobHttpService,
      getY42GitPath(Y42GitFolders.Export),
      Y42Routes.Export,
      inject(Y42RouterService),
      inject(ExportStoreQuery).selectLoading(),
      inject(ExportStoreQuery).selectActiveId(),
    );
  }

  readonly parentType = 'trigger';
  readonly defaultFeatureGitPath = getY42GitPath(Y42GitFolders.Export);
  readonly featureType = Y42FeatureType.Export;
}
